const doGet = (varName: string): string => {

  if (sessionStorage.hasOwnProperty(varName)) {
    return sessionStorage.getItem(varName)!;
  }
  if (localStorage.hasOwnProperty(varName)) {
    return localStorage.getItem(varName)!;
  }

  console.log(`Looking for env var: ${varName}, value:`, process.env[varName]);
  console.log('All VUE_APP_ env vars:', Object.keys(process.env).filter(key => key.startsWith('VUE_APP_')));
  return process.env[varName] || '';

};

export default {
  get(varName: string): string {
    return doGet(varName);
  },
  getBool(varName: string): boolean {
    const val = doGet(varName);
    if (val === 'true') {
      return true;
    } else {
      return false;
    }
  }
};
